module.exports = __webpack_public_path__ + "static/media/lens_diameter_icon.13500973.png";